module.exports = __webpack_public_path__ + "img/3103d0d.png";